import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  // To make sure everything is done correctly in development environment
  strict: process.env.NODE_ENV !== "production"
});
